<template>
<div class="wph-textile-type-picker md:wph--mx-3 md:wph-flex wph-flex-wrap">
  <div v-for="type in preparedTextileTypes" :key="type.id"
       class="wph-mb-4 md:wph-mb-6 md:wph-w-1/2 lg:wph-w-1/3 md:wph-px-3"
  >
    <div @click="selectType(type.id)"
      class="wph-textile-type-picker-simple__card wph-cursor-pointer wph-overflow-hidden
             wph-flex wph-items-center wph-pl-6 xl:wph-pl-8 wph-shadow-md hover:wph-shadow-lg
      "
      :class="type.cssClass"
    >
      <div class="wph-textile-type-picker-simple__card-label wph-text-2xl">{{ type.label }}</div>
      <div class="wph-textile-type-picker-simple__card-icon wph-rounded-full wph-relative wph-overflow-hidden
                  wph-ml-auto">
        <img :src="`${publicPath}img/${type.icon.filename}`" :width="type.icon.w" :height="type.icon.h" :alt="type.label"
             class="wph-absolute"
        >
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "TextileTypePickerSimple",
  props: ['value'],
  data() {
    return {
      publicPath: process.env.BASE_URL,
    }
  },
  computed: {
    appTextileTypes() {
      return this.$store.state.textileTypes.list
    },
    preparedTextileTypes() {
      let typesList = [...this.appTextileTypes]
      const cssClasses = {
        tShirts: 'wph-textile-type-picker-simple__card--tShirts',
        polo: 'wph-textile-type-picker-simple__card--polo',
        sweatshirts: 'wph-textile-type-picker-simple__card--sweatshirts',
        hoodies: 'wph-textile-type-picker-simple__card--hoodies',
        baseballCaps: 'wph-textile-type-picker-simple__card--baseballCaps',
        bags: 'wph-textile-type-picker-simple__card--bags',
      }
      const icons = {
        tShirts: {
          filename: 'textile-type-picker__t-shirt.svg',
          w: 153,
          h: 143,
        },
        polo: {
          filename: 'textile-type-picker__polo.svg',
          w: 149,
          h: 143,
        },
        sweatshirts: {
          filename: 'textile-type-picker__sweatshirt.svg',
          w: 161,
          h: 130,
        },
        hoodies: {
          filename: 'textile-type-picker__hoodie.svg',
          w: 141,
          h: 165,
        },
        baseballCaps: {
          filename: 'textile-type-picker__baseball-cap.svg',
          w: 143,
          h: 89,
        },
        bags: {
          filename: 'textile-type-picker__bag.svg',
          w: 111,
          h: 112,
        },
      }
      return typesList.map((item) => {
        item.cssClass = cssClasses[item.id]
        item.icon = icons[item.id]
        return item
      })
    }
  },
  methods: {
    selectType(id) {
      const type = this.appTextileTypes.filter((type) => type.id === id)[0]
      this.$emit('input', type)
    }
  },
}
</script>